import React, { Fragment } from "react";
//import AdsBanner from "components/Spotlight/AdsBanner";
//import { Container } from "@material-ui/core";
import AxiosConfig from "axiosConfig";
import UserStartedProject from "components/Feeds/UserStartedProject";
import UserCompletedProject from "components/Feeds/UserCompletedProject";
import ProjectInvitation from "components/Feeds/ProjectInvitation";
import UserSetGoal from "components/Feeds/UserSetGoal";
import FriendJoinedProject from "components/Feeds/FriendJoinedProject";
import FriendSetGoal from "components/Feeds/FriendSetGoal";
import FriendCompletedProject from "components/Feeds/FriendCompletedProject";
import "containers/Feeds/Feeds.css";
import * as CONSTANT from "constants/text";
import TextTheme from "components/General/Text/TextTheme";
import "components/Feeds/Feeds.css";
import NewsfeedCommentList from "components/Tribe/Friends/UserDetail/FriendNewsfeed/NewsfeedCommentList";
import ReactionContainer from "components/Tribe/Friends/UserDetail/FriendNewsfeed/ReactionContainer";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import CustomUserPost from "components/Feeds/CustomUserPost";
/**
 * @description Displays the feeds for the user.
 * @class Feeds
 * @implements ProjectInvitation, FriendJoinedProject, UserStartedProject, UserCompletedProject, UserSetGoal,
 * FriendSetGoal
 * @extends React.Component
 * @type {Feeds}
 * @example <Feeds />
 * pre-condition: all the imports
 * post-condition: returnsimport GuardianInvite from './../../components/Feeds/GuardianInvite';
 a form with the feed information for the user.
 * @param none
 * @returns {Feeds}
 */

class FriendNewsfeed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedList: {},
      updatePostList: {},
      page: 1,
      next: false,
      allReactionImages: [],
      profilePic: "",
      username: "",
    };
  }

  componentDidMount() {
    AxiosConfig.get("posts/feeds/" + this.props.username, {
      params: {
        page: 1,
      },
    })
      .then((res) => {

        this.setState({
          feedList: res.data.newsfeed,
          page: 1,
          next: res.data["hasNext"],
        });
      })
      .catch();
    AxiosConfig.get(`posts/reaction_list`).then((res) =>

      this.setState({ allReactionImages: res.data })
      
    );

    this.fetchUserInfo(this);
  }
  fetchUserInfo(obj) {
    AxiosConfig.get(`/profile/user_details/`).then((response) =>
      this.setState((prevState) => ({
        profilePic: response.data[0].profile_pic,
        username: response.data[0].full_name,
      }))
    );
  }
  fetchNewPosts() {
    AxiosConfig.get("posts/feeds/" + this.props.username, {
      params: {
        page: this.state.page + 1,
      },
    })
    
      .then((res) => {
        this.setState({
          feedList: this.state.feedList.concat(res.data.newsfeed),
          page: this.state.page + 1,
          next: res.data["hasNext"],
        });
      })
      .catch();
  }

  render() {
    return (
      <Fragment>
        <div className="newsfeed_columns friend-newsfeed-column">
          <Fragment>
            {this.state.feedList.length > 0 ? (
              <Fragment>
                {this.state.feedList.map((item) =>
                  item.action_type === CONSTANT.POSTS_RECEIVED_INVITATION ? (
                    <div className="friend-newsfeed-wrapper">
                      <ProjectInvitation
                        key={item.id}
                        profilePic={item.friend.user_photo}
                        friendsName={item.friend.full_name}
                        gender={item.gender}
                        time={item.date}
                        projectBanner={item.project.banner}
                        projectName={item.project.name}
                        projectMission={item.project.mission}
                        projectSlug={item.slug}
                        friendEmail={item.friend.user_email}
                        commentList={item.comments}
                        type={CONSTANT.NEWS}
                        userName={item.user.full_name}
                      />
                      <div className="reaction_separator" />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.action_type === CONSTANT.POSTS_JOINED_PROJECT ? (
                    <div className="friend-newsfeed-wrapper">
                      <FriendJoinedProject
                        key={item.id}
                        friendsProfilePic={item.friend.user_photo}
                        friendsName={item.friend.full_name}
                        time={item.date}
                        projectBadge={item.project.badge}
                        projectName={item.project.name}
                        commentList={item.comments}
                        type={CONSTANT.NEWS}
                      />
                      <div className="reaction_separator" />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.action_type === CONSTANT.POSTS_STARTED_PROJECT ? (
                    <div className="friend-newsfeed-wrapper">
                      <UserStartedProject
                        key={item.id}
                        profilePic={item.user.user_photo}
                        userName={item.user.full_name}
                        time={item.date}
                        projectBadge={item.project.badge}
                        projectName={item.project.name}
                        commentList={item.comments}
                        type={CONSTANT.NEWS}
                      />
                      <div className="reaction_separator" />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.action_type === CONSTANT.POSTS_COMPLETED_PROJECT ? (
                    <div className="friend-newsfeed-wrapper">
                      <UserCompletedProject
                        key={item.id}
                        profilePic={item.user.user_photo}
                        userName={item.user.full_name}
                        time={item.date}
                        video={
                          item.project_user.adventure_details.exp_video ||
                          item.project_user.adventure_details.video ||
                          item.project_user.adventure_details.file_upload ||
                          item.project_user.video
                        }
                        projectName={item.project.name}
                        commentList={item.comments}
                        type={CONSTANT.NEWS}
                      />
                      <div className="reaction_separator" />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.action_type === CONSTANT.POSTS_GOAL_SET ? (
                    <div className="friend-newsfeed-wrapper">
                      <UserSetGoal
                        key={item.id}
                        profilePic={item.user.user_photo}
                        userName={item.user.full_name}
                        time={item.date}
                        goalName={item.project_user.challenge_name}
                        projectName={item.project.name}
                        commentList={item.comments}
                        type={CONSTANT.NEWS}
                        goalDate={item.project_user.goal_date}
                        projectBadge={item.project.badge}
                      />
                      <div className="reaction_separator" />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.action_type === CONSTANT.CUSTOM_POST ? (
                    <div className="friend-newsfeed-wrapper">
                      <CustomUserPost
                        key={item.id}
                        userPhoto={item.user.user_photo}
                        userName={item.user.full_name}
                        time={item.date}
                        postPhoto={item.post_image}
                        postBody={item.post_body}
                        youtubeID={item.youtube_id}
                        postVideo={item.post_video}
                      />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.broadcast_type === CONSTANT.POSTS_FRIEND_GOAL_SET ? (
                    <div className="friend-newsfeed-wrapper">
                      <FriendSetGoal
                        key={item.id}
                        profilePic={item.user.user_photo}
                        friendsName={item.user.full_name}
                        time={item.date}
                        goalName={item.project_user.adventure_name}
                        projectName={item.project.name}
                        commentList={item.comments}
                        type={CONSTANT.NEWS}
                      />
                      <div className="reaction_separator" />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.broadcast_type ===
                    CONSTANT.POSTS_FRIEND_COMPLETED_PROJECT ? (
                    <div className="friend-newsfeed-wrapper">
                      <FriendCompletedProject
                        key={item.id}
                        profilePic={item.user.user_photo}
                        friendsName={item.user.full_name}
                        time={item.date}
                        video={
                          item.project_user.adventure_details.exp_video ||
                          item.project_user.adventure_details.video ||
                          item.project_user.adventure_details.file_upload ||
                          item.project_user.video
                        }
                        projectName={item.project.name}
                        commentList={item.comments}
                        type={CONSTANT.NEWS}
                      />
                      <div className="reaction_separator" />
                      <div>
                        <ReactionContainer
                          postId={item.id}
                          reactionList={item.reactions}
                          allReactionImages={this.state.allReactionImages}
                          username={this.state.username}
                        />
                      </div>
                      <div>
                        <NewsfeedCommentList
                          commentList={item.comments}
                          postId={item.id}
                          username={this.state.username}
                          profilePic={this.state.profilePic}
                        />
                      </div>
                    </div>
                  ) : item.action_type === CONSTANT.GROUP_CUSTOM_POST ? (
                    <div className="friend-newsfeed-wrapper">
                      <CustomUserPost
                        key={item.id}
                        userPhoto={item.user.user_photo}
                        userName={item.user.full_name}
                        time={item.date}
                        postPhoto={item.post_image}
                        postBody={item.post_body}
                        youtubeID={item.youtube_id}
                        postVideo={item.post_video}
                        isGroup={true}
                        groupID={item.group.id}
                        groupName={item.group.name}
                      />
                      <ReactionContainer
                        postId={item.id}
                        reactionList={item.reactions}
                        allReactionImages={this.state.allReactionImages}
                        username={this.state.username}
                      />
                      <NewsfeedCommentList
                        commentList={item.comments}
                        postId={item.id}
                        username={this.state.username}
                        profilePic={this.state.profilePic}
                      />
                    </div>
                  ) : null
                )}
              </Fragment>
            ) : (
              <div style={{ textAlign: "center" }}>
                <br />
                <br />
                <TextTheme
                  message={this.props.username + CONSTANT.NO_NEWSFEED}
                  className="text_medium text_med_grey text_bold"
                />
              </div>
            )}
            {this.state.next ? (
              <RoundedButton
                title={CONSTANT.VIEW_MORE_POSTS}
                textThemeClassName="text_small text_light_med_grey"
                handleOnClick={this.fetchNewPosts.bind(this)}
                margin="16px 10px 30px 10px"
                float="right"
              />
            ) : null}
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default FriendNewsfeed;
